import { useCallback, useEffect, useState } from "react";

const KEY = "braw_enquiry";
const EVT = "braw-enquiry-change";

const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

const write = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event(EVT));
};

export const formatEnquiry = (items) =>
  items.map((i) => (i.qty ? `${i.name} × ${i.qty} packs` : i.name)).join(", ");

export function useEnquiry() {
  const [items, setItems] = useState(read);

  useEffect(() => {
    const sync = () => setItems(read());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const has = useCallback((id) => items.some((i) => i.id === id), [items]);
  const add = (p) => { if (!read().some((i) => i.id === p.id)) write([...read(), { id: p.id, name: p.name, qty: "" }]); };
  const remove = (id) => write(read().filter((i) => i.id !== id));
  const toggle = (p) => (read().some((i) => i.id === p.id) ? remove(p.id) : add(p));
  const setQty = (id, qty) => write(read().map((i) => (i.id === id ? { ...i, qty } : i)));
  const clear = () => write([]);

  return { items, has, add, remove, toggle, setQty, clear };
}
